// home page in mobile view add this
document.addEventListener('DOMContentLoaded', function() {
  // Create the new h1 element
  const newH1 = document.createElement('h1');
  newH1.classList.add('hometitle', 'h4-style', 'align-center', 'hide-on-desktop');
  newH1.innerHTML = '<span>Shop By Category</span>';

  // Select the target div element
  const targetDiv = document.getElementById('shopify-section-grid-section');

  // Check if the targetDiv exists
  if (targetDiv) {
    // Insert the new h1 element before the target div
    targetDiv.insertAdjacentElement('beforebegin', newH1);
  } else {
    console.error('Target div not found.');
  }
});


/* Add hide-on-mobile class in all input field that is the type of hidden */
document.addEventListener("DOMContentLoaded", function() {dev
    document.querySelectorAll('.form .input-row').forEach(function(div) {
        if (div.querySelector('input[type="hidden"]')) {
            div.classList.add('hide-on-mobile');
        }
    });
});


/* Truncate title if title word greater than 10 words in mobile screen */
$(document).ready(function() {
    $('.inner .innerer .title').each(function() {
        var content = $(this).text().trim();
        var words = content.split(/\s+/);

        if (window.matchMedia("(max-width: 600px)").matches) {
          if (words.length > 8) {
              var truncated = words.slice(0, 8).join(' ') + '...';
              $(this).text(truncated).addClass('ellipsis');
          }
        }
    });
});


